/**
 * Maps AIMS documentation route paths to content.
 * Paths match AIMS_TOC (e.g. introduction, prerequisites, step1-connection).
 */
import { aimsContent } from "./aimsContent";

export default aimsContent;
